import BaseService from '../base-service';
import NetworkUrls from '../network-urls';

class ZoneService extends BaseService {
  async fetchById(id, lang = 'FR') {
    const variables = { id, lang };
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query ($lang: Lang!, $id: Int!) {
          RoomZone {
              many {
                  name,
                  icon,
                  id
              },
              one (id: $id) {
                  name,
                  icon,
                  room_groups {
                      text (lang: $lang) {
                          name
                      },
                      rooms {
                          id,
                          main_picture {absolute_path},
                          area,
                          text (lang: $lang) {
                              short_desc,
                              short_name
                          },
                          position {
                              lat,
                              lng
                          },
                          room_group {
                            text (lang: $lang) {
                              name
                            }
                          },
                          provider
                      }
                  }
              }
          }
        }`,
        variables,
      },
    };
    return this._exec(config);
  }
}

export const zoneService = new ZoneService();



// WEBPACK FOOTER //
// ./src/network/services/zone.service.js